//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { OpLanguage } from './op-language'
import { OpDistributor } from './op-distributor'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'

export class OpAlarmText
    implements IReferenceType, IOpChangeState, IJsonSerializable
{
    // #region Properties

    public idAlarmText: number
    public idLanguage: number
    public name: string
    public alarmText: string
    public idDistributor: number

    // #endregion

    // #region Navigation Properties

    public language: OpLanguage
    public distributor: OpDistributor

    // #endregion

    // #region Custom Properties



    // #endregion

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion

    // #region IReferenceType

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdAlarmText
    }

    public getReferenceKey(): number {
        return this.idAlarmText
    }

    public getReferenceValue(): any {
        return this
    }

    // #endregion

    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion

    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idAlarmText = opObj.ID_ALARM_TEXT
            this.idLanguage = opObj.ID_LANGUAGE
            this.name = opObj.NAME
            this.alarmText = opObj.ALARM_TEXT
            this.idDistributor = opObj.ID_DISTRIBUTOR

            this.language = opObj._Language == null ? null : new OpLanguage(opObj._Language)
            this.distributor = opObj._Distributor == null ? null : new OpDistributor(opObj._Distributor)

            this.opState = opObj.OpState
        } else {
            this.idAlarmText = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_TEXT: this.idAlarmText,
            ID_LANGUAGE: this.idLanguage,
            NAME: this.name,
            ALARM_TEXT: this.alarmText,
            ID_DISTRIBUTOR: this.idDistributor,

            _Language: this.language == null ? null : this.language.toJSON(),
            _Distributor: this.distributor == null ? null : this.distributor.toJSON(),

            OpState: this.opState
        }
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpAlarmText[]): JQueryPromise<OpAlarmText[]> {
        const defered: JQueryDeferred<OpAlarmText[]> = $.Deferred<OpAlarmText[]>()

        defered.resolve(list)

        return defered.promise()
    }
}
